import { Download } from "lucide-react";
import BrochureImg from "../../../assets-user/Brochure.png";
import { showError, showSuccess } from "../../../utils/toastUtils";

const Brochure = ({ brochureUrl, projectTitle }) => {
  const handleDownload = async () => {
    try {
      if (!brochureUrl) {
        showError("No brochure available to download.");
        return;
      }

      const response = await fetch(brochureUrl);
      if (!response.ok) throw new Error("Failed to fetch brochure file.");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${projectTitle || "Project_Brochure"}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();

      showSuccess("Brochure downloaded successfully!");
    } catch (error) {
      console.error(error);
      showError("Failed to download brochure.");
    }
  };

  return (
    <div className="">
      <div className="mx-auto">
        <div className="bg-white rounded-lg border flex items-center justify-between p-2 md:p-4 lg:p-6">
          {/* Left Section - Icon and Title */}
          <div className="flex items-center gap-3 md:gap-4">
            <div className="flex-shrink-0">
              <img
                src={BrochureImg}
                alt="PDF Brochure"
                className="w-full h-auto object-contain"
              />
            </div>
            <h2 className="hidden md:flex font-medium text-[#031722] tracking-[0.01em] leading-[150%] text-center text-lg sm:text-xl md:text-2xl lg:text-[24px]">
              Brochure
            </h2>
          </div>

          {/* Right Section - Download Button */}
          <div className="flex-shrink-0">
            <button
              onClick={handleDownload}
              disabled={!brochureUrl}
              className={`flex items-center justify-center gap-2 px-2 py-2 md:px-6 md:py-3 border-2 rounded-lg font-semibold transition-colors ${
                brochureUrl
                  ? "border-orange-600 text-orange-600 hover:bg-orange-50"
                  : "border-gray-300 text-gray-400 cursor-not-allowed"
              }`}
            >
              <Download size={20} />
              <span className="block sm:hidden">Download</span>
              <span className="hidden sm:block">Download Brochure</span>
            </button>
          </div>
        </div>

        {/* Show message if no brochure */}
        {!brochureUrl && (
          <div className="text-center text-gray-500 text-sm mt-4">
            No brochure available.
          </div>
        )}
      </div>
    </div>
  );
};

export default Brochure;
